import type { Components, Theme } from '@mui/material/styles';

export const MUI_RADIUS_COMPONENTS: Pick<
  Components<Theme>,
  'MuiOutlinedInput' | 'MuiTextField' | 'MuiCheckbox' | 'MuiRadio' | 'MuiSelect'
> = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.radius.sm,
      }),
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiOutlinedInput-root': {
          borderRadius: theme.radius.sm,
        },
      }),
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.radius.sm,
      }),
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.radius.sm,
      }),
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: ({ theme }) => ({
        borderRadius: theme.radius.md,
      }),
    },
  },
};
